














import {computed, defineComponent, onMounted, onUnmounted, reactive, watchEffect} from '@vue/composition-api'
import {userStore} from '@/store'
import {db} from '@/horizon-firebase'
import {Account} from '@horizon/common/models'
import {account, accountLoading, initAccountWatcher} from '@/watch-account'

const components = {}

/** Account credits component: simple readonly text field */
export default defineComponent({
  name: 'AccountCredits',
  components,
  props: {
  },
  setup(props, context) {
    const currentUserId = computed (() => userStore.uid)

    const credits = computed(() => account.value?.creditsAvailable || 0)

    onMounted(() => {
      watchEffect(() => {
        if (currentUserId.value)
          initAccountWatcher(currentUserId.value)
      })
    })

    return {credits, accountLoading}
  }
})
